import FormOrdersControl from "./form-orders-control/form-orders-control";
import FormSubmission from "./form-submission/form-submission";
import FormValidation from "./form-validation/form-validation";
import FskFormElement from "./fsk-form-element/fsk-form-element";
import Payment from "./payment/payment";

/**
 * Represents an FSK Form
 * all elements templates and styling are defined by FSK
 */
class Form {
  /**
   * @param {HTMLElement} element - webform form
   */
  constructor(element) {
    this.element = element;

    this.config = {
      selectors: {
        fskFormElement: ".FskFormElement",
      },
    };

    this.fskFormElements = [
      ...this.element.querySelectorAll(this.config.selectors.fskFormElement),
    ];

    this._init();
  }

  /**
   * init
   *
   * @private
   */
  _init() {
    this.formValidation = new FormValidation(this.element);

    this.formSubmission = new FormSubmission(this.element);

    this.FormOrdersControl = new FormOrdersControl(this.element);

    this.payment = new Payment(this.element);

    this.fskFormElements.forEach((element) => new FskFormElement(element));
  }
}

export default Form;
